import { Modal } from 'react-bootstrap'
import useGetUsers from './hooks/useGetUsers'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import { useEffect, useState } from 'react'
import { CiSearch } from 'react-icons/ci'
interface ISelectUser {
    name: string
    id: undefined | number
    memberId: undefined | number
}
interface IModalProps {
    show: boolean
    onHide: () => void
    setSelectedUser: React.Dispatch<
        React.SetStateAction<ISelectUser | undefined>
    >
    setMemberId: React.Dispatch<React.SetStateAction<number | undefined>>
    title?: string
}
export default function SelectModal({
    show,
    onHide,
    setSelectedUser,
    setMemberId,
    title,
}: IModalProps) {
    const [select, setSelect] = useState<ISelectUser>()
    const [searchTransaction, setSearchtransaction] = useState<string>(' ')
    const [searchTrans, setSearchTrans] = useState<string>(' ')
    const { data, isLoading, handleSelect } = useGetUsers(
        setSelect,
        searchTransaction
    )

    useEffect(() => {
        if (searchTrans === '') {
            setSearchtransaction('')
        }
    }, [searchTrans])

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" py-3 px-2">
                <p className=" text-center text-sm">
                    {title ? title : 'دریافت کننده را انتخاب کنید'}
                </p>
                <hr className=" my-2" />
                <div className="flex h-[25px]">
                    <input
                        type="text"
                        className=" w-full outline-0 border border-green-1 rounded-full px-2 py-1 ml-3"
                        onChange={(e) => setSearchTrans(e.target.value)}
                        value={searchTrans}
                        placeholder="جستجو..."
                    />
                    <CiSearch
                        className=" text-green-1  w-8 h-full cursor-pointer"
                        onClick={() => {
                            setSearchtransaction(searchTrans)
                        }}
                    />
                </div>
                <div className=" h-72 overflow-y-scroll">
                    {isLoading ? (
                        <DotsLoading />
                    ) : (
                        data &&
                        data.map((item, index) => {
                            if (item.is_active) {
                                return (
                                    <Item
                                        key={item.id}
                                        item={item}
                                        index={index}
                                        handleSelect={handleSelect}
                                        setSelectedUser={setSelect}
                                        setMemberId={setMemberId}
                                    />
                                )
                            }
                        })
                    )}
                </div>
                <div>
                    <hr className=" my-2" />
                    <p
                        className=" text-green-1 text-center"
                        onClick={() => {
                            onHide()
                            setSelectedUser(select)
                        }}
                    >
                        تایید
                    </p>
                </div>
            </div>
        </Modal>
    )
}
